import React from 'react'

import { GiftCardStatusTag } from '../../../../components/GiftCardStatusTag/GiftCardStatusTag'
import { type GiftCard } from '../../GiftCards.types'
import { GiftCardTableCell } from '../GiftCardTableCell/GiftCardTableCell'
import { GiftCardUsageTableCell } from '../GiftCardUsageTableCell/GiftCardUsageTableCell'
import * as S from './GiftCardListItem.styled'

type GiftCardListItemProps = {
  giftCard: GiftCard
}

export const GiftCardListItem = ({ giftCard }: GiftCardListItemProps) => {
  return (
    <S.Container>
      <GiftCardTableCell giftCard={giftCard} />
      <GiftCardStatusTag status={giftCard.status} />
      <S.UsageWrapper>
        <GiftCardUsageTableCell giftCard={giftCard} />
      </S.UsageWrapper>
    </S.Container>
  )
}
